import { createFeatureSelector, createSelector } from '@ngrx/store'
import { USERS_FEATURE_KEY, UsersState, usersAdapter } from './users.reducer'

export const selectUsersState = createFeatureSelector<UsersState>(USERS_FEATURE_KEY)

const { selectAll, selectEntities } = usersAdapter.getSelectors()

export const selectUsersLoaded = createSelector(selectUsersState, (state: UsersState) => state.loaded)

export const selectCount = createSelector(selectUsersState, (state: UsersState) => state.count)

export const selectAllUsers = createSelector(selectUsersState, (state: UsersState) => selectAll(state))

export const selectUsersEntities = createSelector(selectUsersState, (state: UsersState) => selectEntities(state))

export const selectSelectedId = createSelector(selectUsersState, (state: UsersState) => state.selectedId)

export const selectEntity = createSelector(selectUsersEntities, selectSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const selectDataView = createSelector(selectUsersState, (state) => state.dataView)

export const selectSearchHistory = createSelector(selectUsersState, (state: UsersState) => state.searchHistory)

export const selectEditCreateLoaded = createSelector(selectUsersState, (state: UsersState) => state.editCreateLoaded)
export const selectSaveAndSendInviteLoaded = createSelector(
  selectUsersState,
  (state: UsersState) => state.saveAndSendInviteLoaded,
)
export const selectChangePasswordLoaded = createSelector(
  selectUsersState,
  (state: UsersState) => state.changePasswordLoaded,
)
export const selectMessageLoaded = createSelector(selectUsersState, (state: UsersState) => state.messageLoaded)
export const selectInviteLoaded = createSelector(selectUsersState, (state: UsersState) => state.inviteLoaded)
